/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ParticipantRole } from './ParticipantRole.js';
import {
    ParticipantRoleFromJSON,
    ParticipantRoleFromJSONTyped,
    ParticipantRoleToJSON,
} from './ParticipantRole.js';
import type { TenantSettingsConfigEntity } from './TenantSettingsConfigEntity.js';
import {
    TenantSettingsConfigEntityFromJSON,
    TenantSettingsConfigEntityFromJSONTyped,
    TenantSettingsConfigEntityToJSON,
} from './TenantSettingsConfigEntity.js';

/**
 * 
 * @export
 * @interface TenantConfigEntity
 */
export interface TenantConfigEntity {
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    tenantName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    deepgramApiUrl?: string;
    /**
     * 
     * @type {Array<ParticipantRole>}
     * @memberof TenantConfigEntity
     */
    channelRoleMapping?: Array<ParticipantRole>;
    /**
     * 
     * @type {string}
     * @memberof TenantConfigEntity
     */
    supportText?: string;
    /**
     * 
     * @type {TenantSettingsConfigEntity}
     * @memberof TenantConfigEntity
     */
    settings?: TenantSettingsConfigEntity;
}

/**
 * Check if a given object implements the TenantConfigEntity interface.
 */
export function instanceOfTenantConfigEntity(value: object): boolean {
    return true;
}

export function TenantConfigEntityFromJSON(json: any): TenantConfigEntity {
    return TenantConfigEntityFromJSONTyped(json, false);
}

export function TenantConfigEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantConfigEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantName': json['tenantName'] == null ? undefined : json['tenantName'],
        'deepgramApiUrl': json['deepgramApiUrl'] == null ? undefined : json['deepgramApiUrl'],
        'channelRoleMapping': json['channelRoleMapping'] == null ? undefined : ((json['channelRoleMapping'] as Array<any>).map(ParticipantRoleFromJSON)),
        'supportText': json['supportText'] == null ? undefined : json['supportText'],
        'settings': json['settings'] == null ? undefined : TenantSettingsConfigEntityFromJSON(json['settings']),
    };
}

export function TenantConfigEntityToJSON(value?: TenantConfigEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tenantName': value['tenantName'],
        'deepgramApiUrl': value['deepgramApiUrl'],
        'channelRoleMapping': value['channelRoleMapping'] == null ? undefined : ((value['channelRoleMapping'] as Array<any>).map(ParticipantRoleToJSON)),
        'supportText': value['supportText'],
        'settings': TenantSettingsConfigEntityToJSON(value['settings']),
    };
}

